var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverallExpProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#3259A4",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.138 21.763a.687.687 0 1 1 .973.974L21.848 25l2.264 2.263a.688.688 0 1 1-.973.974l-2.75-2.75a.69.69 0 0 1 0-.974l2.75-2.75zm3.723 0a.687.687 0 1 0-.973.974L28.153 25l-2.265 2.263a.688.688 0 1 0 .973.974l2.75-2.75a.69.69 0 0 0 0-.974l-2.75-2.75z",
    fill: "#3259A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 16.75A2.75 2.75 0 0 1 19.5 14h11a2.75 2.75 0 0 1 2.75 2.75v16.5A2.75 2.75 0 0 1 30.5 36h-11a2.75 2.75 0 0 1-2.75-2.75v-16.5zm13.75-1.375h-11a1.375 1.375 0 0 0-1.375 1.375v16.5a1.375 1.375 0 0 0 1.375 1.375h11a1.375 1.375 0 0 0 1.375-1.375v-16.5a1.375 1.375 0 0 0-1.375-1.375z",
    fill: "#3259A4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverallExpProfile);
export default __webpack_public_path__ + "static/media/overallExp-profile.1f68ebce95eb7ef82c4fcffb70f59f7f.svg";
export { ForwardRef as ReactComponent };